module.exports = __webpack_public_path__ + "static/juvencard.7444b748.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/juvencard.png
// module id = 724
// module chunks = 92562407457355